// SPDX-License-Identifier: AGPL-3.0-or-later

import {Button} from '@app/features/ui/button/Button';
import {AudioLevelMeter} from '@app/features/user/components/modals/tabs/components/AudioLevelMeter';
import styles from '@app/features/user/components/modals/tabs/components/MicTestSection.module.css';
import type {MicTestSettings} from '@app/features/user/components/modals/tabs/hooks/useMicTest';
import {useMicTest} from '@app/features/user/components/modals/tabs/hooks/useMicTest';
import VoiceSettings from '@app/features/voice/state/VoiceSettings';
import {Trans} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
import type React from 'react';

interface MicTestSectionProps {
	settings: MicTestSettings;
}
export const MicTestSection: React.FC<MicTestSectionProps> = observer(({settings}) => {
	const {isTesting, level, start, stop} = useMicTest(settings);
	const autoSensitivity = VoiceSettings.vadAutoSensitivity;
	const threshold = VoiceSettings.vadThreshold;
	return (
		<div>
			<div className={styles.label}>
				<Trans>Mic Test</Trans>
			</div>
			<div className={styles.content}>
				<AudioLevelMeter
					level={isTesting ? level : 0}
					thresholdPercent={threshold}
					showThreshold={isTesting && !autoSensitivity}
				/>
				<div className={styles.controls}>
					<Button
						variant="primary"
						fitContainer={false}
						className={styles.actionButton}
						onClick={isTesting ? stop : start}
					>
						{isTesting ? <Trans>Stop Test</Trans> : <Trans>Test Microphone</Trans>}
					</Button>
					{isTesting && (
						<span className={styles.listening}>
							<Trans>Listening...</Trans>
						</span>
					)}
				</div>
			</div>
		</div>
	);
});
